<template>
	<base-data-table
		:service-provider="serviceProvider"
		:vuex-module="vuexModule"
		:header-columns="filteredHeaderColumns"
		:query-params="queryParams"
		label="Company Admins"
	>
		<template v-slot:cell_user="{ value }"
			>{{ value.is_superuser ? "*" : "" }}
			{{ value.first_name }}</template
		>
		<template v-slot:cell_user_email="{ value }">
			<a :href="`mailto:${value}`">{{ value }}</a>
		</template>
    <template v-slot:cell_cash_call_approver="{ value, row }">
      <template v-if="'Superuser' !== $user.get().role">{{
        capitalizeText(value)
      }}</template>
      <base-switch
        v-else
        :id="`cash-call-approver-${row.id}`"
        :value="'Active' == value"
        onText=""
        offText=""
        @click="
          onSwitchCashCallApproverStatus(
            'member',
            row,
            'Active' == value ? 'InActive' : 'Active',
            $event
          )
        "
      ></base-switch>
    </template>
		<template v-slot:cell_status="{ value, row }">
			<template v-if="'Superuser' !== $user.get().role">{{
				capitalizeText(value)
			}}</template>
			<base-switch
				v-else
        :id="`status-${row.id}`"
				:value="'Active' == value"
				onText=""
				offText=""
				@click="
					onSwitchStatus(
						'member',
						row,
						'Active' == value ? 'InActive' : 'Active',
						$event
					)
				"
			></base-switch>
		</template>
    <template v-slot:cell_billing_contact="{ value, row }">
      <template v-if="'Superuser' !== $user.get().role">
        {{ capitalizeText(value) }}
      </template>
      <base-switch
        v-else
        :id="`billing-contact-${row.id}`"
        :value="'Active' == value"
        onText=""
        offText=""
        @click="onSwitchBillingContact(row, 'Active' == value ? 'InActive' : 'Active', $event)"
      ></base-switch>
    </template>
	</base-data-table>
</template>

<script>
import Vue from "vue";
import { capitalize } from "lodash-es";

import { companyAdminsTableData } from "@datas";
import { statusSwitchMixin } from "@mixins";

import BaseDataTable from "@components/BaseDataTable";
import Members from '@services/Members'

export default {
	name: "table-company-admins",
	mixins: [statusSwitchMixin],
	components: {
		BaseDataTable,
	},
	inject: ["companySvc", "memberSvc"],
	data() {
		return {
			...companyAdminsTableData,
		};
	},
  computed: {
    filteredHeaderColumns() {
      const company = this.companySvc.company
      const showCashCallApprover = !!(company && company.tpa_internal_approval_required)
      const showBillingContact = !!(company && company.role && company.role.role === 'TPA')

      return this.headerColumns.filter(col => {
        if (col.prop === 'cash_call_approver') return showCashCallApprover
        if (col.prop === 'billing_contact') return showBillingContact
        return true
      })
    }
  },
	methods: {
		capitalizeText(value) {
			return capitalize(value);
		},
    async onSwitchBillingContact(row, newValue, event) {
      if (event) event.preventDefault()

      const name = row.user.first_name

      Vue.prototype.$swal({
        title: 'Confirmation',
        text: `Are you sure you want to ${
          newValue === 'Active' ? 'designate' : 'remove'
        } ${name} as a Billing Contact?`,
        type: 'warning',
        confirmButtonText: 'Okay',
        preConfirm: async (confirm) => {
          if (!confirm) return false

          const resp = await Members.toggleBillingContactStatus(
            row.id,
            'Active' !== row.billing_contact
          )

          // Check for error in response directly since axios may not throw
          if (resp.data && resp.data.data && resp.data.data.status === 400) {
            Vue.prototype.$swal({
              title: 'Error',
              text: resp.data.data.message || 'Failed to update billing contact status.',
              type: 'error',
              confirmButtonText: 'Okay'
            })
            return false
          }

          // Write the saved member back to the members store this table
          // renders from, so the switch shows the new state (same as
          // TableCompanyUsers.vue / TableUsers.vue).
          this.$store.commit('UPDATE_MEMBER', { data: resp.data.data.data })

          return true
        }
      })
    },
	},
	created() {
		this.serviceProvider = this.memberSvc;
		this.queryParams.company_id = this.companySvc.company.id;
	},
	beforeDestroy() {
		this.$bus.destroyEvents();
	},
};
</script>
